// @flow

export const roles = Object.freeze({
  Cafeteria: 'Cafeteria', // сотрудник столовой
  Dealer: 'Dealer', // сотрудник оператора
  School: 'School', // сотрудник ОУ
  Admin: 'Admin', // администратор системы
  Template: 'Template', // создано по шаблону
});

export type Role = $Values<typeof roles>
